<template lang="pug">
    div(@change="Reset")
      el-button.ButtonNext(@click="showDialog = true" type="primary" v-show="show") Retroalimentación
      v-dialog(v-model="showDialog" persistent max-width="930px")
        v-layout(row, justify-center)
          v-flex(text-xs-center)
            v-card
              div(v-if="showDialog")
                v-layout
                  v-flex(text-xs-center)
                    img.dialog_img(:src="getImage")
                v-spacer.my-1.py-4
                v-card-text.headline
                  | {{ getFeedback.title }}
                v-card.questionCard(flat)
                  v-card-text.dialog_text
                    p.text-sm-left.px-4.px-sm-5(v-for="label in getFeedback.labels")
                      | {{label.text}}
              ButtonNext.buttones
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonNext from "@/components/button-next/button-next";
import { debug } from 'util';
export default {
  name: 'MultipleFeedbackModal',
  components: {
    ButtonNext
  },
  watch: {
    currentStep: {
      handler(val) {
        this.show = val.check || false;
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['currentStep']),
    getFeedback() {
    	console.log("Puntos: ",this.currentStep.points);
    	if(this.currentStep.state == true){
        return this.currentStep.feedbacksModal.find(f => f.type === 'positive');
    	}else{
    		return this.currentStep.feedbacksModal.find(f => f.type === 'negative');
    	}
    },
    getImage() {
        return require(this.getFeedback.type === 'positive' ? '@/assets/ManoArriba.png' : '@/assets/ManoStop.png');
    }
  },
	data(){
    return {
      showDialog: false,
      show: false
		}
	},
  mounted:function(){
    this.show = false;
    this.showDialog = false;
  },
	methods:{
		change(){
			this.state = true;
		},
    Reset(){
      this.currentStep.state = false;
    }
  }
}
</script>
